export const useIsProduction = () => {
  const isProduction =
    window.location.href.includes('wizard.altlayer.io') ||
    window.location.href.includes('dev.autonome.fun');

  return isProduction;
};
